import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

export class BaseService {
  protected apiBaseUrl: string = environment.urlBaseApi;
  searchParameters: URLSearchParams[] = [];
  token: string | null = null;
  // apiBaseUrl: string = environment.urlBaseApi;
  jwtToken = null;

  constructor(
    protected endpoint: string,
    protected httpClient: HttpClient,
    protected authService: AuthService
  ) {}
  // Método para obtener la URL completa
  protected getFullUrl(path: string = ''): string {
    return `${this.apiBaseUrl}${this.endpoint}${path ? `/${path}` : ''}`;
  }

  // Métodos CRUD básicos
  get(path: string = '', params?: any): Observable<any> {
  const url = this.getFullUrl(path);
  return this.httpClient.get(url, { params })
    .pipe(catchError(this.handleError));
  }
  
  post(data: any, path: string = '', params?: any): Observable<any> {
    const url = this.getFullUrl(path);
    return this.httpClient.post(url, data, { params })
      .pipe(catchError(this.handleError));
  }


  put(data: any, path: string = ''): Observable<any> {
    return this.httpClient.put(this.getFullUrl(path), data)
      .pipe(catchError(this.handleError));
  }

  delete(path: string = ''): Observable<any> {
    return this.httpClient.delete(this.getFullUrl(path))
      .pipe(catchError(this.handleError));
  }

  patch(data: any, url: string): Observable<any> {
    return this.httpClient.patch(url, data);
  }

  getById(id?: number, customHeaders: any = {}) {
    const url = id ? `${this.apiBaseUrl}${this.endpoint}/${id}` : `${this.apiBaseUrl}${this.endpoint}`;
    return this.httpClient.get<any>(url, { headers: customHeaders })
      .pipe(catchError(this.handleError));
  }

  deleteById(id?: number) {
    const url = id ? `${this.apiBaseUrl}${this.endpoint}/${id}` : `${this.apiBaseUrl}${this.endpoint}`;
    return this.httpClient.delete<any>(url)
      .pipe(catchError(this.handleError));
  }

  downloadFile(id?: number) {
    const url = `${this.apiBaseUrl}${this.endpoint}/${id}`;
    return this.httpClient.get(url, { responseType: 'blob' })
      .pipe(catchError(this.handleError));
  }

  uploadFile(urlSuffix: string, file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.httpClient.post<any>(`${this.apiBaseUrl}${this.endpoint}/${urlSuffix}`, formData)
      .pipe(catchError(this.handleError));
  }

  patchResource(resource: any, urlExtension: string = '', params: any = {}) {
    const url = `${this.apiBaseUrl}${this.endpoint}${urlExtension ? '/' + urlExtension : ''}`;
    return this.httpClient.patch<any>(url, resource)
      .pipe(catchError(this.handleError));
  }

  putResource(resource: any, urlExtension: string = '', params: any = {}) {
    const url = `${this.apiBaseUrl}${this.endpoint}${urlExtension ? '/' + urlExtension : ''}`;
    return this.httpClient.put<any>(url, resource)
      .pipe(catchError(this.handleError));
  }

  postResource(resource: any, urlExtension: string = '', params: any = {}) {
    const url = `${this.apiBaseUrl}${this.endpoint}${urlExtension ? '/' + urlExtension : ''}`;
    return this.httpClient.post<any>(url, resource)
      .pipe(catchError(this.handleError));
  }

  batchUpdate(resource: any, urlExtension: string = '') {
    const url = `${this.apiBaseUrl}${this.endpoint}/batch${urlExtension ? '/' + urlExtension : ''}`;
    return this.httpClient.put<any>(url, resource)
      .pipe(catchError(this.handleError));
  }

  downloadFilePost(id: any, body: any, docType: string = 'application/pdf'): any {
    const idUrl = id ? `/${id}` : '';
    return this.httpClient.post(`${this.apiBaseUrl}${this.endpoint}${idUrl}`, body, { responseType: 'blob' });
  }

  // Paginación
  getPaginated(page: number, size: number): Observable<any> {
    return this.get(`?page=${page}&size=${size}`);
  }

  // Búsqueda
  search(query: string): Observable<any> {
    return this.get(`?search=${encodeURIComponent(query)}`);
  }

  protected handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Client-side error: ${error.error.message}`;
    } else {
      errorMessage = `Server-side error: Code ${error.status}, Message: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
  findAll(params: any = {}): Observable<any[]> {
    const url = this.getFullUrl();
    return this.httpClient.get<any[]>(url, { params }).pipe(catchError(this.handleError));
  }
  
}